import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/ServicePage";
import { SERVICES } from "@/data/services";
import { buildServiceSchemas } from "@/lib/seo";

const SLUG = "fekjavitas-eger" as const;
const content = SERVICES.find((s) => s.slug === SLUG)!;
const url = `https://lakroszautoszerviz.com/${SLUG}`;

export const Route = createFileRoute("/fekjavitas-eger")({
  head: () => ({
    meta: [
      { title: content.metaTitle },
      { name: "description", content: content.metaDescription },
      { property: "og:title", content: content.metaTitle },
      { property: "og:description", content: content.metaDescription },
      { property: "og:url", content: url },
      { property: "og:type", content: "website" },
      { property: "og:site_name", content: "LAKROSZ Autószerviz" },
      { property: "og:locale", content: "hu_HU" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: content.metaTitle },
      { name: "twitter:description", content: content.metaDescription },
    ],
    links: [{ rel: "canonical", href: url }],
    scripts: buildServiceSchemas(content, url),
  }),
  component: () => <ServicePage content={content} />,
});
